import React from "react";

const labels = {
  paye: { txt: "Payé", cls: "bg-emerald-50 text-emerald-700 border border-emerald-200" },
  partiel: { txt: "Partiel", cls: "bg-amber-50 text-amber-700 border border-amber-200" },
  impaye: { txt: "Impayé", cls: "bg-red-50 text-red-700 border border-red-200" },
};

export default function StatusBadge({ statut }) {
  const conf = labels[statut] || labels.impaye;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-sm text-[11px] font-semibold uppercase tracking-wider ${conf.cls}`}
      data-testid={`status-${statut}`}
    >
      {conf.txt}
    </span>
  );
}
